import {evolve} from './object'

export interface Options {
  level?: number | string
  on?: boolean
}

export const DEBUG = 3
export const INFO = 2
export const WARN = 1
export const ERROR = 0

const options: {
  level: number,
  on: boolean
} = {
  level: ERROR,
  on: false
}

const validateLevel = (level: string | number): number => {
  if (typeof level === 'number') {
    return level > DEBUG ? DEBUG : level
  }

  switch (level) {
    case 'error': return ERROR
    case 'warn': return WARN
    case 'debug': return DEBUG
    default: return INFO
  }
}

const evolveOptions = evolve({
  level: validateLevel
})

export const init = ($options: Options) => {
  Object.assign(options, evolveOptions($options || {}))

  const levels = ['debug', 'info', 'warn', 'error']

  for (const level of levels) {
    if (!console.hasOwnProperty(level)) {
      // @ts-ignore
      console[level] = console.log
    }
  }
}

export const getLevelText = (): string => {
  if (!options.on) {
    return 'off'
  }

  switch (options.level) {
    case ERROR: return 'error'
    case WARN: return 'warn'
    case INFO: return 'info'
    case DEBUG: return 'debug'
    default: return 'off'
  }
}

export default function (thing: any, messageLevel: number = INFO): void {
  messageLevel = validateLevel(messageLevel)

  if (!options.on || messageLevel > options.level) {
    return
  }

  const prepend = '[mol-ads-cmp]'

  switch (messageLevel) {
    case DEBUG:
      console.debug(`${prepend} [DEBUG] `, thing)
      break

    case INFO:
      console.info(`${prepend} [INFO] `, thing)
      break

    case WARN:
      console.warn(`${prepend} [WARN] `, thing)
      break

    case ERROR:
      console.error(`${prepend} [ERROR] `, thing)
      break

    default:
      console.log(thing)
      break
  }
}
